import React from 'react'

import PropTypes from 'prop-types'

const Hide = ({size = 24}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M18.9 6.165a12.3 12.3 0 0 1 4.305 5.58.75.75 0 0 1 0 .51A12.517 12.517 0 0 1 12 20.25a11.467 11.467 0 0 1-5.617-1.575L2.558 22.5 1.5 21.442 21.442 1.5 22.5 2.558l-3.6 3.607Zm-4.309 7.329A3 3 0 0 0 15 12a2.998 2.998 0 0 0-.42-1.5l-4.08 4.08a3 3 0 0 0 4.091-1.086Zm-7.09 4.071A9.788 9.788 0 0 0 12 18.75c3.975 0 8.175-2.947 9.698-6.75a10.904 10.904 0 0 0-3.878-4.755l-2.152 2.153a4.5 4.5 0 0 1-6.263 6.262L7.5 17.565Z"
        fill="currentColor"
      />
      <path
        d="m3.93 16.883 1.073-1.065A10.545 10.545 0 0 1 2.303 12C3.825 8.197 8.025 5.25 12 5.25a9.284 9.284 0 0 1 3 .54l1.163-1.17A11.04 11.04 0 0 0 12 3.75 12.518 12.518 0 0 0 .795 11.745a.75.75 0 0 0 0 .51 12 12 0 0 0 3.135 4.627Z"
        fill="currentColor"
      />
      <path
        d="M9 11.798a3 3 0 0 1 2.775-2.775l1.358-1.365a4.5 4.5 0 0 0-5.498 5.497L9 11.798Z"
        fill="currentColor"
      />
    </svg>
  )
}

Hide.propTypes = {
  size: PropTypes.number,
}

export default Hide
